<template>
  <!-- begin::Page loader -->
  <div class="premainloader d-flex flex-column justify-content-center align-items-center">
    <img alt="Logo" :src="logo" width="100" v-if="logo"/>
    <div class="spinner mt-3" v-bind:class="spinnerClass || 'spinner-primary'"></div>
  </div>
  <!-- end::Page Loader -->
</template>

<script>
export default {
  name: "PreLoader",
  props: {
    logo: String,
    spinnerClass: String
  }
};
</script>
<style scoped>
.premainloader{
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: whitesmoke;
}
</style>
